import type { Action } from 'react-sweet-state';
import type { State } from '../../types';

export const setIsCompleted =
	(isCompleted: boolean): Action<State> =>
	({ setState }) => {
		setState({ isCompleted });
	};
